import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive.ts';
import { useIsEditorPage } from '@confluence/route-manager/entry-points/useIsEditorPage.ts';

import { PageMode } from './enums.ts';

export const useGetPageMode = (): PageMode => {
	const isLivePage = useIsCurrentPageLive();
	const isEditorPage = useIsEditorPage();

	let pageMode = PageMode.VIEW;
	if (isLivePage) {
		pageMode = PageMode.LIVE;
	} else if (isEditorPage) {
		pageMode = PageMode.EDIT;
	}
	return pageMode;
};
